// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__5ik6P","social":"hero_social__-fAVT"};